import { getStoreStatus } from "@/lib/assets";

export const StoreStatusBadge = ({ className = "" }) => {
  const s = getStoreStatus();
  if (!s.label) return null;
  return (
    <span
      data-testid="store-status-badge"
      className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-semibold ${
        s.open ? "bg-leaf/15 text-forest" : "bg-clay/10 text-clay"
      } ${className}`}
    >
      <span className={`h-2 w-2 rounded-full ${s.open ? "bg-leaf" : "bg-clay"} ${s.open ? "animate-pulse" : ""}`} />
      {s.label}
    </span>
  );
};
